import { yupResolver } from "@hookform/resolvers/yup";
import { getJobRelatedExpenseFieldsYupOnSaveSchema } from "entities/JobRelatedExpense";
import * as yup from "yup";

export function getCardCostLineOnSaveValidationSchema(cardFormat) {
  const jobRelatedExpenseSchema = getJobRelatedExpenseFieldsYupOnSaveSchema();
  return yupResolver(
    yup.object().shape({
      ...jobRelatedExpenseSchema,
      attachments: yup.array().of(yup.number()),
      amount: yup
        .string()
        .required("Amount field is required")
        .matches(/^[\d .-]+/, "Amount must be a number")
        .matches(
          /^([\d -]+(?:[.,]\d{1,999})?)$/,
          "Add fractional number after decimal point or comma"
        )
        .matches(
          /^([\d -]+(?:[.,]\d{1,2})?)$/,
          "No more than two digits after decimal separator are allowed"
        ),
      comment: yup.string(),
      cost_type: yup.mixed(),
      posting_entity: yup
        .string()
        .when((_, schema) =>
          cardFormat === "corporate" ? schema.nullable() : schema
        ),
      vat: yup.mixed(),
      posting_gl_code: yup.mixed().when((_, schema) =>
        cardFormat === "corporate"
          ? schema.nullable()
          : schema.test("gl-number", "GL number is required", (obj) => {
              return typeof obj?.value === "string";
            })
      ),
    })
  );
}
